module.exports = __webpack_public_path__ + "static/img_0273_dpp_optimized-a9dd68fe70e1e70d93de96acff7f25e8.jpg";